import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IAllPharmaciesResponse, Pharmacy } from 'src/app/_models/PSP/pharmacy.model';
import { GenericResponse, Response } from 'src/app/_models/response.model';

@Injectable({
  providedIn: 'root'
})
export class PharmaciesService {

  pharmaciesUrl = 'api/AdminPspPharmacies/';
  getAllPharmaciesUrl: string = 'api/AdminPspPharmacies/GetAllPharmacies';
  constructor(private http: HttpClient) { }

  getPspPharmaciesByAreaId(areaId: number, isInsulinProgram: boolean): Observable<Response<{pharmacies: Pharmacy[]}>> {
    const params = {
      areaId: areaId?.toString(),
      isInsulinProgram: isInsulinProgram
    }
    return this.http.get<Response<{pharmacies: Pharmacy[]}>>(this.pharmaciesUrl + 'GetPspPharmacies', {params});
  }

  searchPspPharmacies(areaId: number, pharmacyName: string, isInsulinProgram: boolean): Observable<Response<{pharmacies: Pharmacy[]}>> {
    const params = {
      areaId: areaId.toString(),
      pharmacyName,
      isInsulinProgram: isInsulinProgram
    };
    return this.http.get<Response<{pharmacies: Pharmacy[]}>>(this.pharmaciesUrl + 'SearchPspPharmacies', {params});
  }

  getAllPharmacies(searchValue: string){
    if(searchValue){
      let params = new HttpParams().set('search', searchValue);
      return this.http.get<GenericResponse<IAllPharmaciesResponse>>(this.getAllPharmaciesUrl, {params});
    }
    return this.http.get<GenericResponse<IAllPharmaciesResponse>>(this.getAllPharmaciesUrl);
  }
}
